import React from "react"
import { useMediaQuery } from "react-responsive"
import { Contactus } from "src/openapi"
import { Box, Grid, Typography } from "src/UILibrary"

type Props = {
  item: Contactus
}

export const ContactTableItem = ({ item }: Props) => {
  const isPC = useMediaQuery({ query: "(min-width: 1400px)" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  return (
    <Box
      sx={{
        ":hover": { opacity: 0.8, cursor: "pointer" },
      }}
    >
      {isTablet ? (
        <Grid
          container
          sx={{
            mt: "0px",
            borderBottom: "1px dotted #D4D3D7",
            minHeight: "80px",
          }}
        >
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 1.5 : isTablet ? 2 : 1}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            {item.updatedAt?.slice(0, 16).replace("T", " ")}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 2}
            sm={12}
            xs={12}
            fontSize={16}
            sx={{ my: "auto", px: "20px" }}
          >
            {item.name}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2.5 : isTablet ? 3 : 2.5}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            {item.email}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 2}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            {item.company}
          </Grid>
          <Grid
            item
            color="text.primary"
            md={isPC ? 4 : isTablet ? 3 : 2}
            sm={12}
            xs={12}
            sx={{
              my: "auto",
              px: "20px",
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
            }}
          >
            <Typography.InputFieldRequired
              fontSize={12}
              className="notosans weight500"
              sx={{ overflowWrap: "break-word", maxWidth: "450px" }}
            >
              {item.context}
            </Typography.InputFieldRequired>
          </Grid>
        </Grid>
      ) : (
        <Box display="display" sx={{ borderBottom: "1px dotted #D4D3D7" }}>
          <Box display="flex">
            <Box
              className="notosans weight500"
              color="text.primary"
              fontSize={14}
              width={250}
              sx={{ mt: "10px", ml: "10px" }}
            >
              {item.updatedAt?.slice(0, 16).replace("T", " ")}
            </Box>
            <Box sx={{ mt: "12px", ml: "30px", width: "100%" }}>
              <Typography.InputFieldRequired
                sx={{
                  p: "0px 10px",
                  width: "fit-content",
                  color: "#235496",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderRadius: "4px",
                  borderColor: "#235496",
                  fontSize: "13px",
                }}
              >
                {item.email}
              </Typography.InputFieldRequired>
            </Box>
          </Box>
          <Box className="notosans weight500 limit_line" sx={{ p: "0px 10px 0px", mb: "10px" }}>
            {item.name}
          </Box>
          <Box
            className="notosans weight500 restrict_line"
            sx={{
              fontSize: "12px",
              p: "0px 10px 10px",
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
            }}
          >
            <Typography.InputFieldRequired
              fontSize={12}
              className="notosans weight500"
              sx={{ overflowWrap: "break-word" }}
            >
              {item.context}
            </Typography.InputFieldRequired>
          </Box>
        </Box>
      )}
    </Box>
  )
}
